import { VsScannerService } from './vs-scanner.service';
import { Component, OnInit, forwardRef, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { BarcodeScannerLivestreamComponent } from 'ngx-barcode-scanner';

@Component({
  selector: 'app-vs-scanner',
  templateUrl: './vs-scanner.component.html',
  styleUrls: [ './vs-scanner.component.scss' ],
  providers: [

    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => VsScannerComponent),
      multi: true
    }
  ]
})
export class VsScannerComponent implements OnInit, ControlValueAccessor {


  public barcodeValue;

  private _model: any;
  private onChange: (m: any) => void;
  private onTouched: (m: any) => void;

  public scanEnabled = false;

  public allowedFormats = [];

  constructor(private scannerService: VsScannerService) { }

  get model() {
    return this._model;
  }

  writeValue(value: any): void {
    this._model = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  set(value: any) {
    this._model = value;
    this.onChange(this._model);
  }


  scanErrorHandler(e: Event) {
    console.log('Error ', e);
    this.scanEnabled = false;
  }

  scanFailureHandler(e: Event) {
    console.log('Failure ', e);
    this.scanEnabled = false;
  }

  scanCompleteHandler(e: Event) {
    console.log('Complete ', e);
    this.scanEnabled = false;
  }

  toggleScan() {
    setTimeout(() => {
      this.scanEnabled = !this.scanEnabled;
    }, 10);

  }

  scanSuccessHandler(result) {
    this.barcodeValue = result;
    setTimeout(() => {
      this.scanEnabled = false;
    }, 10);
    this.scannerService.emit(result);
    this.set(result);
  }

  onStarted(started) {
    console.log(started);
  }

  ngOnInit() {
  }

}
